import { useState } from 'react';
import { useDispatch } from 'react-redux';
import type { ApiError } from '~/_shared/utils/api/apiError.helpers';
import { mapReset } from '~/store/map/map.actionCreators';
import { spreadsheetResetStateAndRefetchData } from '~/store/spreadsheetData/spreadsheetData.actionCreators';
import {
  type SpreadsheetTableDataUpdateRequest, updateSpreadsheetRows,
} from '../spreadsheet/spreadsheet.repository';
import { useSpreadsheetDataOutOfSync } from './useSpreadsheetDataOutOfSync';

export const useUpdateSpreadsheetData = () => {
  const dispatch = useDispatch();
  const { onConcurrencyError } = useSpreadsheetDataOutOfSync();

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const updateSpreadsheetData = (
    clientId: number,
    spreadsheetId: number,
    request: SpreadsheetTableDataUpdateRequest,
    onSuccess: () => void
  ) => {
    setIsLoading(true);
    setIsError(false);

    return updateSpreadsheetRows(clientId, spreadsheetId, request)
      .then((response) => {
        if (response.type === 'concurrency-error') {
          onConcurrencyError();
        }
        else {
          onSuccess();
          dispatch(spreadsheetResetStateAndRefetchData());
        }
      })
      .catch((e: ApiError) => {
        if (e.responseStatus === 403) {
          dispatch(mapReset());
        }
        else {
          setIsError(true);
          throw e;
        }

      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const clearUpdateError = () => {
    setIsError(false);
  };

  return {
    isLoading,
    isError,
    clearUpdateError,
    updateSpreadsheetData,
  };
};
